'use strict';

let script = document.getElementById('js-translations-hydration');
let translationsData = script ? JSON.parse(script.innerHTML) : {};
let { trans, transChoice, load } = require('@pepita-i18n/babelfish');

load(translationsData);

module.exports = { trans, transChoice };
